module.exports = require("npm:util-deprecate@1.0.2/browser.js");